import { elementSettings as sdkElementSettings } from '@yola/ws-sdk';
import Context from './helpers/element-settings-context';
import components from './components';
import stages from './constants/stages';
import { targetAttributes } from './constants/target-attributes';
import { targetClasses } from './constants/target-classes';
import { breakpointKeys } from './constants/breakpoints';
import helpers from './helpers';
import verifiers from './verifiers';
import hooks from './hooks';

export default {
  Context,
  components,
  constants: {
    triggerTypes: sdkElementSettings.constants.triggerTypes,
    stages,
    targetAttributes,
    targetClasses,
    breakpointKeys,
  },
  filters: sdkElementSettings.filters,
  helpers,
  verifiers,
  hooks,
};
